import { gql, useLazyQuery, useMutation } from "@apollo/client";

export const useFileUpload = () => {
    const UPLOAD_FILE = gql`
  mutation UploadFile($file: Upload!) {
    uploadFile(file: $file) {
      filename
      mimetype
      encoding
    }
  }
`;
  const [uploadFile] = useMutation(UPLOAD_FILE);

  const handleFileUpload = async file => {
    try {
       
      const { data } = await uploadFile({ variables: { file } });
     
      console.log('File uploaded:', data.uploadFile);
    } catch (error) {
     
      console.error('Error uploading file in HandleFile UPLOAD IS :', error);
    }
  };

  return { handleFileUpload };
};
